import React, { useState, useEffect, useCallback } from 'react';
import { sendContact, resetContactState } from './../../store/contact/contact.actions';
import Input from '../../core/Input/Input';
import Button from '../../core/Button/Button';
import Error from './../../components/Error/Error';
import { useSelector, useDispatch } from 'react-redux';
import Spinner from '../../core/Spinner/Spinner';
import './Contact.scss';
import { Helmet } from "react-helmet";

export interface IContactForm {
    name: string,
    tel?: string,
    email: string,
    message: string
};

const Contact: React.FC<{}> = React.memo(() => {
    const [ contactForm, setContactForm ] = useState<IContactForm>({ name: '', email: '', message: '' });
    const { error, fetching, msgSent } = useSelector((state: any) => state.contactStore);
    const dispatch = useDispatch();
    const resetContact = useCallback(() => { dispatch(resetContactState()); }, [dispatch]);

    useEffect(() => { resetContact(); }, [resetContact]);

    const onFormChange = (event: any = {}) => {
        setContactForm({
            ...contactForm,
            [event.target.id]: event.target.value
        });
    };

    const handleSubmit = (evt: any) => {
        evt.preventDefault();
        evt.stopPropagation();
        if (contactForm.email === '' || contactForm.name === '' || contactForm.message === '') {
            return;
        } 

        dispatch(sendContact(contactForm));
    };

    const renderContact = () => {
        if (error) {
            return <Error retry={resetContact} />;
        }

        if (fetching) {
            return <Spinner>Enviando mensaje...</Spinner>;
        }

        if (msgSent) {
            return <p>Gracias por comunicarse con nosotros! Le responderemos a la brevedad.</p>
        }

        return (
            <form
                name="contactForm"
                onSubmit={handleSubmit}>
                <div className="row">
                    <div className="col-md-6">
                        <div className="form-group">
                            <Input 
                                id="name"
                                type="text"
                                className="form-control"
                                value={contactForm.name}
                                change={onFormChange} 
                                placeholder="Nombre" 
                                required={true} 
                            />
                        </div>
                        <div className="form-group">
                            <Input 
                                id="tel" 
                                type="number" 
                                className="form-control"
                                value={contactForm.tel}
                                change={onFormChange} 
                                placeholder="Teléfono" 
                                required={false} 
                            />
                        </div>
                        <div className="form-group">
                            <Input 
                                id="email" 
                                type="email" 
                                className="form-control"
                                value={contactForm.email}
                                change={onFormChange} 
                                placeholder="Email" 
                                required={true} 
                            />
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-group MsgContainer">
                            <textarea 
                                id="message"
                                value={contactForm.message}
                                required
                                className="form-control" 
                                onChange={onFormChange}>
                            </textarea>
                        </div>
                    </div>
                </div>
                <div className="row SendBtnContainer">
                    <div className="col-md-12">
                        <Button type="submit">ENVIAR</Button>
                    </div>
                </div>
            </form>
        );
    };

    return (
        <div className="Contacto">
            <Helmet>
                <title>Héctor Blejer | Contacto</title>
                <meta name="description" content="Hector Blejer. Representaciones comerciales" />
                <meta name="keywords" content="Hector Blejer, hector, blejer, fabrica, fabricas, distribuidor, insumos, limpieza, representaciones comerciales, comercial, representacion, productos, negocios" />
            </Helmet>
            <div className="container SectionContainer">
                <h3 className="SectionTitle">Contacto</h3>
                <p>Si Ud. aún no es cliente y desea solicitar serlo, o tiene consultas o preguntas, no dude en comunicarse conmigo y responderé a la brevedad.</p>
                <div className="ContactoContent">
                    {renderContact()}
                </div>
            </div>
        </div>
    );
});

export default Contact;